export type PluralMap = Record<string, string>;

export const days: PluralMap = {
  'zero': $localize`:@@plurals.days_0:дней`,
  'one': $localize`:@@plurals.days_1:день`,
  'few': $localize`:@@plurals.days_2:дня`,
  'many': $localize`:@@plurals.days_0:дней`,
  'other': $localize`:@@plurals.days_0:дней`
};

export const hours: PluralMap = {
  'zero': $localize`:@@plurals.hours_0:часов`,
  'one': $localize`:@@plurals.hours_1:час`,
  'few': $localize`:@@plurals.hours_2:часа`,
  'many': $localize`:@@plurals.hours_0:часов`,
  'other': $localize`:@@plurals.hours_0:часов`
};

export const minutes: PluralMap = {
  'zero': $localize`:@@plurals.minutes_0:минут`,
  'one': $localize`:@@plurals.minutes_1:минута`,
  'few': $localize`:@@plurals.minutes_2:минуты`,
  'many': $localize`:@@plurals.minutes_0:минут`,
  'other': $localize`:@@plurals.minutes_0:минут`
};

export const seconds: PluralMap = {
  'zero': $localize`:@@plurals.seconds_0:секунд`,
  'one': $localize`:@@plurals.seconds_1:секунда`,
  'few': $localize`:@@plurals.seconds_2:секунды`,
  'many': $localize`:@@plurals.seconds_0:секунд`,
  'other': $localize`:@@plurals.seconds_0:секунд`
};

export const weeks: PluralMap = {
  'zero': $localize`:@@plurals.weeks_0:недель`,
  'one': $localize`:@@plurals.weeks_1:неделя`,
  'few': $localize`:@@plurals.weeks_2:недели`,
  'many': $localize`:@@plurals.weeks_0:недель`,
  'other': $localize`:@@plurals.weeks_0:недель`
};

export const skins: PluralMap = {
  'zero': $localize`:@@plurals.skins_0:скинов`,
  'one': $localize`:@@plurals.skins_1:скин`,
  'few': $localize`:@@plurals.skins_2:скина`,
  'many': $localize`:@@plurals.skins_0:скинов`,
  'other': $localize`:@@plurals.skins_0:скинов`
};

export const points: PluralMap = {
  'zero': $localize`:@@plurals.points_0:поинтов`,
  'one': $localize`:@@plurals.points_1:поинт`,
  'few': $localize`:@@plurals.points_2:поинта`,
  'many': $localize`:@@plurals.points_0:поинтов`,
  'other': $localize`:@@plurals.points_0:поинтов`
};

export const wagerGames: PluralMap = {
  'zero': $localize`:@@plurals.wager_games_0:отыгровок`,
  'one': $localize`:@@plurals.wager_games_1:отыгровка`,
  'few': $localize`:@@plurals.wager_games_2:отыгровки`,
  'many': $localize`:@@plurals.wager_games_0:отыгровок`,
  'other': $localize`:@@plurals.wager_games_0:отыгровок`
};

export const games: PluralMap = {
  'zero': $localize`:@@plurals.games_0:игр`,
  'one': $localize`:@@plurals.games_1:игра`,
  'few': $localize`:@@plurals.games_2:игры`,
  'many': $localize`:@@plurals.games_0:игр`,
  'other': $localize`:@@plurals.games_0:игр`
};

export function getPluralForm(value: number): string {
  const absValue = Math.abs(value) % 100;
  const lastDigit = absValue % 10;

  if (absValue >= 11 && absValue <= 19) {
    return days['many'];
  }

  if (lastDigit === 1) {
    return days['one'];
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return days['few'];
  }

  return days['many'];
}